import { useParams, useLocation } from 'react-router-dom';
import { useReport } from '../../../../../api/hooks/useReport';
import { useMemo } from 'react';
import { useSources } from '../../../../../api/hooks/useSources';
import BannerReclamiDettaglio from '../../../../../components/report/listaDriverPage/reclami/reclami-dettaglio/BannerReclamiDettaglio';
import useElementReclamiDettaglio from '../../../../../api/hooks/useElementReclamiDettaglio';
import ContainerReclamiDettaglio from '../../../../../components/report/listaDriverPage/reclami/reclami-dettaglio/ContainerReclamiDettaglio';
import { useEventsSearch } from '../../../../../api/hooks/useEventsSearch';

const ReclamiDettaglioPage = () => {
  const {driverRoute, intermediarioName } = useParams<{
    name: string;
    driverRoute: string;
    intermediarioName: string;
  }>();

  const location = useLocation();
  const { idReport, driverId, key } = location.state || {};

const { report, loading: loadingReport, error: errorReport } = useReport(idReport);
const { elements, loading: loadingElements, error: errorElements } = useElementReclamiDettaglio(idReport, driverId, key);
const { sources, loading: loadingSources, error: errorSources } = useSources(idReport, driverId, key);

const payload = useMemo(() => ({
  report_id: idReport,
  element_id: key,
}), [idReport, key]);

const { events } = useEventsSearch(payload);

  if (loadingElements || loadingReport || loadingSources) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="w-20 h-20 border-[6px] border-gray-300 border-t-textPrimary rounded-full animate-spin" />
      </div>
    );
  }

  if (errorElements || errorReport || errorSources) {
    return <div>Si è verificato un errore durante il caricamento.</div>;
  }

  const intermediario = Array.isArray(elements) ? elements[0] : elements;

  if (!intermediario) {
    return <div>Nessun market maker trovato per questo ID.</div>;
  }

  return (
    <div className="flex flex-col bg-gray-50">
      <BannerReclamiDettaglio
        report={report}
        title={driverRoute!}
        intermediarioName={intermediarioName}
        reportId={idReport}
        driverId={driverId}
      />
      <div className="px-8 lg:px-16 py-8">
        <ContainerReclamiDettaglio
        intermediario={intermediario}
        title={driverRoute!}
        id={idReport}
        driverId={driverId}
        intermediarioId={key}
        sources={sources}
        events={events}
      />
      </div>
    </div>
  );
};

export default ReclamiDettaglioPage;
